import { Checkbox, FormControlLabel, FormGroup } from "@mui/material"
import React, { useCallback } from "react"
import {
    useCreateSpammerMutation,
    useDeleteSpammerMutation,
    useExistsSpammerQuery
} from "../../core/api/spammer-api"

const SpammerControl = ({ userId, project }) => {
    const { data, isLoading, isFetching } = useExistsSpammerQuery(
        { project, userId },
        { skip: userId === "" }
    )

    const [createSpammer] = useCreateSpammerMutation()
    const [deleteSpammer] = useDeleteSpammerMutation()

    const handleChange = useCallback(() => {
        if (isLoading || isFetching) return
        if (data) {
            deleteSpammer({ project, userId })
        } else {
            createSpammer({ project, userId })
        }
    }, [userId, project, data, isLoading, isFetching, createSpammer, deleteSpammer])

    return (
        <FormGroup>
            <FormControlLabel
                control={(
                    <Checkbox
                        disableRipple
                        disabled={isLoading || isFetching}
                        checked={data ?? false}
                        onChange={handleChange}
                    />
                )}
                label="Auto-close Zendesk tickets"
            />
        </FormGroup>
    )
}

export default SpammerControl
